/* eslint-disable max-len */
export const SERVICE_MESSAGES = {
  SPECIAL_ORDER: 'Special Order',
  VISIT_PRO_DESK: 'Please visit your local Pro Desk or call our Pro Support Team to discuss pricing and availability. Call ',
  DELIVERY_AVAILABILITY: '. Delivery and availability may vary by zip code.',
  PHONE_NUMBER: '1-844-410-5464',
};
export const HOME_DEPOT_QUOTE_CENTER = 'HDQC';
